

// import { AnnouncementsCard } from '@backstage-community/plugin-announcements';
import { Content, Header, Page } from '@backstage/core-components';
import {
    ClockConfig,
    HeaderWorldClock,
    HomePageRecentlyVisited,
    HomePageToolkit,
    HomePageTopVisited,
    Tool,
    WelcomeTitle
} from '@backstage/plugin-home';
import { HomePageSearchBar } from '@backstage/plugin-search';
import { SearchContextProvider } from '@backstage/plugin-search-react';
import { Grid, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    searchBarInput: {
        maxWidth: '60vw',
        margin: 'auto',
        backgroundColor: theme.palette.background.paper,
        borderRadius: '50px',
        boxShadow: theme.shadows[1],
    },
    searchBarOutline: {
        borderStyle: 'none',
    },
}));
import BuildIcon from '@material-ui/icons/Build';

const clockConfigs: ClockConfig[] = [{
    label: 'Polska',
    timeZone: 'CET'
}
];
const timeFormat: Intl.DateTimeFormatOptions = {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
};

const welcomeTitleLanguages = ['English', 'Spanish', 'Italian', 'French', 'German', 'Polish', 'Greek'];

const HomePage = () => {
    // const app = useApp();

    const classes = useStyles();


    const tools: Tool[] = [
        // { url: '/faktury', label: 'Faktury', icon: <InvoicingIcon /> },
        { url: '/naprawy', label: 'Naprawy', icon: <BuildIcon /> },

    ];

    return (<SearchContextProvider>
        <Page themeId="home">
            <Header title={
                <WelcomeTitle language={welcomeTitleLanguages} />
            } pageTitleOverride="Home">
                <HeaderWorldClock clockConfigs={clockConfigs} customTimeFormat={timeFormat} />
            </Header>
            <Content>
                <Grid container justifyContent="center" spacing={6}>
                    <Grid container item xs={12} justifyContent="center">
                        <HomePageSearchBar InputProps={{
                            classes: {
                                root: classes.searchBarInput,
                                notchedOutline: classes.searchBarOutline
                            }
                        }} placeholder="Search" />
                    </Grid>
                    <Grid container item xs={12}>
                        <Grid item xs={12} md={4}>
                            <HomePageToolkit tools={tools} title='Narzędzia' />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <HomePageTopVisited />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <HomePageRecentlyVisited />
                        </Grid>
                    </Grid>
                </Grid>
            </Content>
        </Page>
    </SearchContextProvider>);
};

export default HomePage;
